import PageStepLayout from "@Client/@Modules/application-standalone/components/layout/page-step-layout.vue";
import PageSectionGroupLayout from "@Client/@Modules/application-standalone/components/layout/page-section-group-layout.vue";
import SubjectPropertyExistingMortgage from "@Client/@Modules/application-standalone/components/pages/subject-property/subject-property-existing-mortgage.vue";
import { useScrollTopOnLoad } from "@Shared/@Composables/generic/useScrollTopOnLoad";
import { defineComponent, computed, watch, toRefs, ref, onBeforeUnmount, onMounted } from "@vue/composition-api";
import SectionTitle from "@Client/@Modules/application-standalone/components/helpers/section-title.vue";
import DateField from "@Shared/components/form-elements/fields/date-field.vue";
import SelectField from "@Shared/components/form-elements/fields/select-field.vue";
import TextField from "@Shared/components/form-elements/fields/text-field.vue";
import CurrencyField from "@Shared/components/form-elements/fields/currency-field.vue";
import RadioField from "@Shared/components/form-elements/fields/radio-field.vue";
import PercentageField from "@Shared/components/form-elements/fields/percentage-field.vue";
import { APPLICATION_FIELD_OPTIONS } from "@Shared/@Utils/application-defaults-utils/global-field-options";
import { useSubjectPropertyHelpers } from "@Client/@Composables/application-standalone/pages/subject-property/useSubjectPropertyHelpers";
import { useSummaryHelpers } from "@Client/@Composables/application-standalone/pages/summary/useSummaryHelpers";
import { APPLICATION_FLOW } from "@Shared/@Types/application/application-enums";
import AddressFieldGroup from "@Shared/components/form-elements/field-groups/address-field-group.vue";
import { subjectPropertyValidator } from "@Client/@Composables/application-standalone/validations/subjectPropertyPageValidator";
import { subjectPropertyPageBindingsAndVisibilities } from "@Client/@Composables/application-standalone/pages/subject-property/subjectPropertyPageBindingsAndVisibilities";
import { get } from "lodash";
import { PAGE_TOGGLER_TARGET, usePageTogglers } from "@Client/@Composables/application-standalone/page-helpers/usePageToggler";
export default defineComponent({
  name: "SubjectPropertyPage",
  components: {
    PageStepLayout,
    PageSectionGroupLayout,
    SubjectPropertyExistingMortgage,
    DateField,
    SelectField,
    TextField,
    RadioField,
    CurrencyField,
    PercentageField,
    SectionTitle,
    AddressFieldGroup
  },
  props: {
    showErrors: {
      type: Number,
      default: 0
    }
  },
  setup(props, {
    emit
  }) {
    const {
      showErrors
    } = toRefs(props);
    const addressFieldComponent = ref();
    const extraValidation = ref(true);
    const {
      handlePageTogglerNavigation
    } = usePageTogglers();
    useScrollTopOnLoad();
    const {
      currentFlow
    } = useSummaryHelpers();
    const {
      bindings,
      visibilities
    } = subjectPropertyPageBindingsAndVisibilities();
    const {
      propertyDetailsOccupancy,
      propertyDetailsPurchaseDate,
      propertyDetailsLivingSpace,
      propertyDetailsAppraisedValue,
      propertyDetailsAppraisalDate,
      propertyDetailsBlock,
      propertyDetailsConcTownship,
      propertyDetailsEstimatedValue,
      propertyDetailsLot,
      propertyDetailsMlsListing,
      propertyDetailsMonthlyIncome,
      propertyDetailsRentalProperty,
      propertyStylePropertyStyle,
      propertyStylePropertyType,
      propertyStyleGarageSize,
      propertyStyleConstructionType,
      propertyStyleEnvironmentalHazard,
      propertyStyleHeat,
      propertyStyleLotSize,
      propertyStyleGarageStyle,
      propertyStyleLotSizeType,
      propertyStyleNumberOfUnits,
      propertyStyleSewageInfo,
      propertyStyleStructureAge,
      propertyStyleTenure,
      propertyStyleWaterInfo,
      propertyAddress,
      propertyCostsFeesIncludeHeat,
      propertyCostsHeating,
      propertyCostsHydro,
      propertyCostsInsurance,
      propertyCostsInterest,
      propertyCostsMaintenanceFees,
      propertyCostsManagement,
      propertyCostsOthers,
      propertyCostsPercOfTotalMaintFees,
      propertyCostsPropertyTaxes,
      propertyCostsRentalIncomeOptions,
      propertyCostsRentalIncomeOptionsPercent,
      propertyCostsRepairs,
      propertyCostsTaxResponsible,
      propertyCostsTaxYear,
      subjectProperty
    } = bindings;
    const {
      propertyStyleOptions,
      propertyTypeOptions,
      propertyGarageSizeOptions,
      propertyGarageStyleOptions,
      propertyUnitOfMeasurementOptions,
      propertySewageTypeOptions,
      propertyHeatingTypeOptions,
      propertyDetailsOccupancyOptions,
      propertyRentalIncomeSelectOptions,
      propertyConstructionTypeOptions,
      propertyTenureOptions,
      yesNoOptions,
      propertyWaterInfoOptions,
      propertyTaxResponsibleOptions
    } = APPLICATION_FIELD_OPTIONS();
    const {
      propertyHasExistingMortgages,
      addExistingMortgage,
      handleChangeIsThePropertyStillMortgaged,
      showSubjectPropertyExistingMortgages
    } = useSubjectPropertyHelpers();
    const handleNavigateNext = () => {
      emit("navigate-next");
    };
    const handleNavigateBack = () => {
      emit("navigate-back");
    };
    const {
      propertyDetailsOccupancyVisible,
      propertyDetailsPurchaseDateVisible,
      propertyDetailsLivingSpaceVisible,
      propertyDetailsAppraisedValueVisible,
      propertyDetailsAppraisalDateVisible,
      propertyDetailsBlockVisible,
      propertyDetailsConcTownshipVisible,
      propertyDetailsEstimatedValueVisible,
      propertyDetailsLotVisible,
      propertyDetailsMlsListingVisible,
      propertyDetailsMonthlyIncomeVisible,
      propertyDetailsRentalPropertyVisible,
      propertyAddressVisible,
      propertyStylePropertyStyleVisible,
      propertyStyleConstructionTypeVisible,
      propertyStyleEnvironmentalHazardVisible,
      propertyStyleHeatVisible,
      propertyStyleLotSizeVisible,
      propertyStyleGarageStyleVisible,
      propertyStyleLotSizeTypeVisible,
      propertyStyleNumberOfUnitsVisible,
      propertyStyleSewageInfoVisible,
      propertyStyleStructureAgeVisible,
      propertyStyleTenureVisible,
      propertyStyleWaterInfoVisible,
      propertyStylePropertyTypeVisible,
      propertyStyleGarageSizeVisible,
      propertyCostsFeesIncludeHeatVisible,
      propertyCostsHeatingVisible,
      propertyCostsHydroVisible,
      propertyCostsInsuranceVisible,
      propertyCostsInterestVisible,
      propertyCostsMaintenanceFeesVisible,
      propertyCostsManagementVisible,
      propertyCostsOthersVisible,
      propertyCostsPercOfTotalMaintFeesVisible,
      propertyCostsPropertyTaxesVisible,
      propertyCostsRentalIncomeOptionsVisible,
      propertyCostsRentalIncomeOptionsPercentVisible,
      propertyCostsRepairsVisible,
      propertyCostsTaxResponsibleVisible,
      propertyCostsTaxYearVisible,
      existingMortgagesIsVisible
    } = visibilities;
    const isPurchaseSelected = computed(() => currentFlow.value === APPLICATION_FLOW.PURCHASE);
    const {
      v$
    } = subjectPropertyValidator();
    watch(showErrors, newVal => {
      if (newVal) {
        var _v$$value, _v$$value$propertyAdd, _addressFieldComponen;
        v$ == null ? void 0 : (_v$$value = v$.value) == null ? void 0 : _v$$value.$touch();
        if ((_v$$value$propertyAdd = v$.value.propertyAddress) != null && _v$$value$propertyAdd.$invalid) (_addressFieldComponen = addressFieldComponent.value) == null ? void 0 : _addressFieldComponen.openManualAddress(true);
      }
    });
    const getValidator = path => get(v$.value, path, null);
    onBeforeUnmount(() => {
      emit("show-errors", 0);
    });
    onMounted(() => {
      handlePageTogglerNavigation({
        target: PAGE_TOGGLER_TARGET.INFORMATION
      });
      emit("update:showInformationPage", true);
    });
    return {
      subjectProperty,
      propertyDetailsOccupancy,
      propertyDetailsPurchaseDate,
      propertyDetailsLivingSpace,
      propertyDetailsAppraisedValue,
      propertyDetailsAppraisalDate,
      propertyDetailsBlock,
      propertyDetailsConcTownship,
      propertyDetailsEstimatedValue,
      propertyDetailsLot,
      propertyDetailsMlsListing,
      propertyDetailsMonthlyIncome,
      propertyDetailsRentalProperty,
      propertyStylePropertyStyle,
      propertyStylePropertyType,
      propertyStyleGarageSize,
      propertyStyleConstructionType,
      propertyStyleEnvironmentalHazard,
      propertyStyleHeat,
      propertyStyleLotSize,
      propertyStyleGarageStyle,
      propertyStyleLotSizeType,
      propertyStyleNumberOfUnits,
      propertyStyleSewageInfo,
      propertyStyleStructureAge,
      propertyStyleTenure,
      propertyStyleWaterInfo,
      propertyAddress,
      propertyCostsFeesIncludeHeat,
      propertyCostsHeating,
      propertyCostsHydro,
      propertyCostsInsurance,
      propertyCostsInterest,
      propertyCostsMaintenanceFees,
      propertyCostsManagement,
      propertyCostsOthers,
      propertyCostsPercOfTotalMaintFees,
      propertyCostsPropertyTaxes,
      propertyCostsRentalIncomeOptions,
      propertyCostsRentalIncomeOptionsPercent,
      propertyCostsRepairs,
      propertyCostsTaxResponsible,
      propertyCostsTaxYear,
      handleNavigateNext,
      handleNavigateBack,
      propertyStyleOptions,
      propertyTypeOptions,
      propertyGarageSizeOptions,
      propertyGarageStyleOptions,
      propertyUnitOfMeasurementOptions,
      propertySewageTypeOptions,
      propertyHeatingTypeOptions,
      propertyDetailsOccupancyOptions,
      propertyRentalIncomeSelectOptions,
      propertyConstructionTypeOptions,
      propertyTenureOptions,
      yesNoOptions,
      propertyWaterInfoOptions,
      propertyTaxResponsibleOptions,
      propertyHasExistingMortgages,
      addExistingMortgage,
      propertyDetailsOccupancyVisible,
      propertyDetailsPurchaseDateVisible,
      propertyDetailsLivingSpaceVisible,
      propertyDetailsAppraisedValueVisible,
      propertyDetailsAppraisalDateVisible,
      propertyDetailsBlockVisible,
      propertyDetailsConcTownshipVisible,
      propertyDetailsEstimatedValueVisible,
      propertyDetailsLotVisible,
      propertyDetailsMlsListingVisible,
      propertyDetailsMonthlyIncomeVisible,
      propertyDetailsRentalPropertyVisible,
      propertyAddressVisible,
      propertyStylePropertyStyleVisible,
      propertyStyleConstructionTypeVisible,
      propertyStyleEnvironmentalHazardVisible,
      propertyStyleHeatVisible,
      propertyStyleLotSizeVisible,
      propertyStyleGarageStyleVisible,
      propertyStyleLotSizeTypeVisible,
      propertyStyleNumberOfUnitsVisible,
      propertyStyleSewageInfoVisible,
      propertyStyleStructureAgeVisible,
      propertyStyleTenureVisible,
      propertyStyleWaterInfoVisible,
      propertyStylePropertyTypeVisible,
      propertyStyleGarageSizeVisible,
      propertyCostsFeesIncludeHeatVisible,
      propertyCostsHeatingVisible,
      propertyCostsHydroVisible,
      propertyCostsInsuranceVisible,
      propertyCostsInterestVisible,
      propertyCostsMaintenanceFeesVisible,
      propertyCostsManagementVisible,
      propertyCostsOthersVisible,
      propertyCostsPercOfTotalMaintFeesVisible,
      propertyCostsPropertyTaxesVisible,
      propertyCostsRentalIncomeOptionsVisible,
      propertyCostsRentalIncomeOptionsPercentVisible,
      propertyCostsRepairsVisible,
      propertyCostsTaxResponsibleVisible,
      propertyCostsTaxYearVisible,
      isPurchaseSelected,
      v$,
      handleChangeIsThePropertyStillMortgaged,
      showSubjectPropertyExistingMortgages,
      existingMortgagesIsVisible,
      getValidator,
      addressFieldComponent,
      extraValidation
    };
  }
});